// extracted by mini-css-extract-plugin
export default {"collage-container":"Library_collage-container__M2Sj-","vinyls-collage-container":"Library_vinyls-collage-container__fhD5D","table-image":"Library_table-image__N6NMj"};